import React, { useState, useRef, useEffect } from "react";
import CountUp from "react-countup";
import countIcon1 from "../../assets/images/counter/1.png";
import countIcon2 from "../../assets/images/counter/2.png";
import countIcon3 from "../../assets/images/counter/3.png";
import countIcon4 from "../../assets/images/counter/4.png";
import Faq from "../../components/Faq";
import { SERVER_URL } from "../../api/url";
import axios from "axios";
import { debounce } from "lodash"; // Import debounce

const FaqContainer = () => {
  const [visibleCounters, setVisibleCounters] = useState([]);
  const countersRef = useRef([]);
  const [counters, setCounter] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchInfoDebounced = debounce(fetchInfo, 1000); // Debounce fetchInfo by 1000ms (1 second)
    fetchInfoDebounced();

    return () => {
      fetchInfoDebounced.cancel(); // Cancel debounce on unmount
    };
  }, []);

  const fetchInfo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/about/total_infomation`);
      const fetchedData = response?.data?.data || {};

      // Transform the fetched data into an array of objects that can be used in `map()`
      const countersArray = Object.keys(fetchedData).map((key, index) => {
        return {
          countTitle: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize the title
          countNum: fetchedData[key],
          countSubtext: key, // Use the key as subtext (you can adjust this as needed)
          countIcon: [countIcon1, countIcon2, countIcon3, countIcon4][index], // Map icons to the counters
        };
      });

      setCounter(countersArray);
    } catch (err) {
      console.error("Error fetching data:", err);
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = countersRef.current.indexOf(entry.target);
            if (index !== -1 && !visibleCounters.includes(index)) {
              setVisibleCounters((prev) => [...prev, index]);
            }
          }
        });
      },
      { threshold: 0.1 }
    );
    const currentCounters = countersRef.current;
    currentCounters.forEach((el) => el && observer.observe(el));

    return () => {
     currentCounters.forEach((el) => el && observer.unobserve(el));
    };
  }, [visibleCounters]);

  return (
    <div className="student_satisfaction-section pt---110 pb---120">
      <div className="container">
        <div className="react__title__section-all pb---30">
          <div className="row">
            <div className="col-md-12 text-center">
              <h6 className="wow animate__fadeInUp" data-wow-duration="0.3s">
                Faq
              </h6>
              <h2
                className="react__tittle wow animate__fadeInUp"
                data-wow-duration="0.5s"
              >
                Frequently Ask <br />
                Question
              </h2>
            </div>
          </div>
        </div>

        <div>
        {
          !loading && (
            <Faq />
          )
        }
        </div>
      </div>

      {counters && (
        <div className="count__area2 pb---100">
          <div className="container">
            <ul className="row">
              {counters.map((counter, index) => (
                <li
                  key={index}
                  className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 d-flex justify-content-center"
                  ref={(el) => (countersRef.current[index] = el)}
                >
                  <div className="count__content">
                    <div className="icon">
                      <img src={counter.countIcon} alt="icon" />
                    </div>
                    <div className="text">
                      <CountUp
                        start={visibleCounters.includes(index) ? 0 : counter.countNum}
                        end={counter.countNum}
                        duration={10}
                      />
                      <em>+</em>
                      <p className="count__content">{counter.countTitle}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default FaqContainer;
